import { PluginSystem } from '../../utils/hooks';

export class DisabledSnapshotHandler {
  hooks = new PluginSystem({});
}
